<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'HomeworkManage'
}
</script>

<style>

</style>